"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonBar = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var warning_1 = tslib_1.__importDefault(require("warning"));
var button_1 = require("../button");
var config_context_1 = require("../_util/config-context");
exports.ButtonBar = react_1.forwardRef(function (props, ref) {
    var list = props.list, onSelect = props.onSelect, className = props.className, style = props.style;
    var selected = props.selected;
    var classPrefix = config_context_1.useConfig().classPrefix;
    // 统一成标量，方便对比
    if (selected && typeof selected === "object") {
        selected = selected.value;
    }
    warning_1.default(false, "ButtonBar 组件已废弃，请改用 Segment");
    return (react_1.default.createElement("div", { ref: ref, className: classnames_1.default(classPrefix + "-segment", className), style: style }, list.map(function (item, index) { return (react_1.default.createElement(button_1.Button, { key: index, type: "primary", title: item.tip, className: classnames_1.default({
            "is-selected": selected && item.value === selected,
        }), disabled: item.disabled, onClick: item.disabled ? null : function () { return onSelect(item); } },
        item.name,
        item.icon)); })));
});
exports.ButtonBar.displayName = "ButtonBar";
//# sourceMappingURL=ButtonBar.js.map